import React from 'react'

export const Footer = (): React.ReactElement => {
	return (
		<>
			<footer className="footer">
				<div className="container">
					<div className="row">
						<ul className="rack-double">
							<li>&copy; Dun &amp; Bradstreet, Inc. 2000-{new Date().getFullYear()}. All rights reserved.</li>
							<li>
								<a
									href="https://www.dnb.com/utility-pages/privacy-policy.html"
									title="privacy policy"
									rel="external"
								>
									Privacy Policy
								</a>
							</li>
							<li>
								<a
									href="https://www.dnb.com/utility-pages/accessibility.html"
									title="accessibility"
									rel="external"
								>
									Accessibility
								</a>
							</li>
							<li>
								<a
									href="https://www.dnb.com/utility-pages/terms-of-use.html"
									title="accessibility"
									rel="external"
								>
									Terms of use
								</a>
							</li>
						</ul>
					</div>
				</div>
			</footer>
		</>
	)
}
